<script setup lang="ts">
    import { getConfig, klinikenApi } from "@/api";
    import InfoIcon from "@/assets/info_dark.svg";
    import KForm from "@/components/forms/Form/KForm.vue";
    import { useStore } from "@/store";
    import { openNLLErrorDialog } from "@/tabs/Receptforskrivning/helpers";
    import { ref } from "vue";

    const store = useStore();

    const props = defineProps<{
        forskrivningId?: string;
        parallellId?: string;
    }>();

    const forskrivningId = ref(props.forskrivningId);
    const parallellId = ref(props.parallellId);

    const emit = defineEmits(["submit", "close"]);

    const close = () => {
        emit("close");
    };

    const submit = async (data: any) => {
        emit("submit", {
            data,
            forskrivning_id: forskrivningId.value,
            parallell_id: parallellId.value,
            typ: "makulera",
        });
    };

    const getCancellationReasonOptions = async () => {
        try {
            const response = await klinikenApi.get(
                "/nll/kodverk/makuleringsskal/",
                getConfig({ headers: store.getters["nll/headers"] })
            );
            const endReasonOptions = response.data.map((reason: any) => {
                return {
                    value: reason.code,
                    label: reason.display,
                };
            });
            return endReasonOptions;
        } catch (error: any) {
            openNLLErrorDialog({ error, description: "Det gick inte att hämta orsaker till makulering." });
        }
        return [];
    };
</script>

<template>
    <KForm
        id="makulera-forskrivning"
        class="makulera-forskrivning"
        submit-content="Makulera förskrivning"
        submit-variant="alert"
        @submit="submit"
        cancel-content="Avbryt"
        @cancel="close"
    >
        <div class="form-content">
            <div class="intro-info span-all">
                <img :src="InfoIcon" class="intro-info-icon" />
                <div class="intro-info-text">
                    <p>
                        Du vill makulera förskrivningen, på grund av att förskrivningen är felaktigt registrerad och
                        inte ska användas av patienten.
                    </p>
                    <p>
                        Om förskrivningen är korrekt men patienten inte längre behöver läkemedlet eller behandlingstiden
                        är över, välj istället avsluta.
                    </p>
                    <p v-if="parallellId">
                        Om du makulerar en förskrivning som är parallell, makuleras även den andra automatiskt.
                    </p>
                </div>
            </div>
            <KAutocomplete
                name="orsak"
                label="Orsak makulering"
                :options="getCancellationReasonOptions"
                class="span-all"
                validation="required"
            />
            <KText name="beskrivning_orsak" label="Beskrivning av orsak" class="span-all" />
        </div>
    </KForm>
</template>

<style lang="scss">
    .makulera-forskrivning {
        .intro-info {
            display: flex;
            align-items: start;
            gap: 0.5rem;

            img {
                margin-top: 0.2rem;
            }

            .intro-info-text {
                display: flex;
                flex-direction: column;
                gap: 1.5rem;
            }
        }
    }
</style>
